module.exports = __webpack_public_path__ + "static/media/02.Stage View.ba93e31f.JPG";